// Forum gamification (docs/FORUM-FLARUM.md §18): levels, EXP, medals, the game chip, the Progress page and the
// Leaderboard. Routes + model attributes (extend), the post strip, the user card, the profile and sidebar links.
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Extend from 'flarum/common/extenders';
import User from 'flarum/common/models/User';
import Discussion from 'flarum/common/models/Discussion';
import UserPage from 'flarum/forum/components/UserPage';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import LinkButton from 'flarum/common/components/LinkButton';
import UserPageResolver from 'flarum/forum/resolvers/UserPageResolver';
import ProgressPage from './ProgressPage';
import LeaderboardPage from './LeaderboardPage';
import addStrip from './strip';
import addUserCard from './usercard';
import addManage from './manage';
import { t, gamifyOf, ACH_TOTAL } from './ui';
class AchievementsPage extends ProgressPage {
  oninit(vnode) {
    vnode.attrs.focus = 'achievements';
    super.oninit(vnode);
  }
}
export const gamifyExtend = [new Extend.Routes().add('aethernal.leaderboard', '/leaderboard', LeaderboardPage).add('user.aetProgress', '/u/:username/progress', ProgressPage, UserPageResolver).add('user.aetAchievements', '/u/:username/achievements', AchievementsPage, UserPageResolver), new Extend.Model(User).attribute('aetGamify'), new Extend.Model(Discussion).attribute('aetGuide')];
export default function initGamify() {
  addStrip();
  addUserCard();
  addManage();
  extend(UserPage.prototype, 'navItems', function (items) {
    const user = this.user;
    const g = gamifyOf(user);
    if (!user || !g) return;
    items.add('aetProgress', m(LinkButton, {
      href: app.route('user.aetProgress', {
        username: user.slug()
      }),
      icon: "fas fa-chart-line"
    }, t('nav_progress'), " ", m("span", {
      className: "Button-badge"
    }, `Lv ${g.lv}`)), 85);
    items.add('aetAchievements', m(LinkButton, {
      href: app.route('user.aetAchievements', {
        username: user.slug()
      }),
      icon: "fas fa-medal"
    }, t('achievements'), " ", m("span", {
      className: "Button-badge"
    }, `${(g.medals || []).length}/${ACH_TOTAL}`)), 84);
  });
  extend(IndexSidebar.prototype, 'navItems', function (items) {
    items.add('aetLeaderboard', m(LinkButton, {
      href: app.route('aethernal.leaderboard'),
      icon: "fas fa-ranking-star"
    }, t('lb_title')), 95);
  });
}
flarum.reg.add('aethernal-forum', 'forum/gamify', initGamify);